import type { Person } from '../../api/src/shared/contract';

/** Exact email match against the directory. SCIM-provisioned addresses always agree. */
export function findByEmail(people: Person[], email: string): Person | undefined {
  const wanted = email.trim().toLowerCase();
  if (!wanted) return undefined;
  return people.find((p) => p.email.toLowerCase() === wanted);
}

export function assigneesInGroup(people: Person[], groupId: number): Person[] {
  return people
    .filter((p) => p.agent && p.groupIds?.includes(groupId))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase() || '?';
}

export function formatBytes(size: number): string {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}
